import { render, staticRenderFns } from "./MasterRoom.vue?vue&type=template&id=7bc22b1a&scoped=true&"
import script from "./MasterRoom.vue?vue&type=script&lang=js&"
export * from "./MasterRoom.vue?vue&type=script&lang=js&"
import style0 from "./MasterRoom.vue?vue&type=style&index=0&id=7bc22b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc22b1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow})
